import { useMutation, useQueryClient } from '@tanstack/react-query'
import { usersApi, CreateUserPayload } from '../api/users.api'
import { usersKeys } from '../api/users.keys'

export function useCreateUser() {
    const queryClient = useQueryClient()

    return useMutation<any, Error, CreateUserPayload>({
        mutationFn: usersApi.createUser,
        onSuccess: () => {
            // Invalidate all user lists (active + deleted) so UI updates immediately
            queryClient.invalidateQueries({ queryKey: usersKeys.all, exact: false })
            queryClient.invalidateQueries({ queryKey: usersKeys.allUsers(true) })
            queryClient.invalidateQueries({ queryKey: usersKeys.allUsers(false) })
        },
    })
}
